import type { GlobalSearchFeatures } from './config';

export const GlobalSearchTrackingIds = {
  searchField: 'globalsearch-txt-search-field',
  viewAllResults: 'globalsearch-btn-view-all-results',
  closeExpandedView: 'globalsearch-btn-close-expanded-view',
  mobileSearchOpen: 'globalsearch-btn-search-open',
  viewAllFeature: (feature: GlobalSearchFeatures) => `globalsearch-btn-view-all-${feature}`,
  searchType: (feature: GlobalSearchFeatures) => `globalsearch-drpo-${feature}-search-type`,
  searchTypeFilter: 'globalsearch-btn-search-type-filter',
  recentSearchType: (feature: string) => `globalsearch-btn-${feature}-recent-search-type`,
  searchResultItem: (feature: GlobalSearchFeatures) => `globalsearch-btn-${feature}-search-result-item`,
};

export const GlobalSearchModuleOrder = {
  contacts: 0,
  messaging: 1,
  settings: 2,
  features: 3,
};

export const SearchableElements = ['Weave', 'Messages', 'Patients', 'Faxes', 'Settings', 'Features', 'Weave'];
